// extracted by mini-css-extract-plugin
module.exports = {"PromptsTable":"PromptsTable_PromptsTable__3OHjv"};